import { Outlet, createFileRoute, useParams } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";
import { CertificationKind } from "@/routes/_staff/certification/-constants";

import { CertificationProfileHeader } from "../../-components/CertificationProfileHeader";
import { useGetPersonHandlingCertificationHeader } from "../../-queries";

export const Route = createFileRoute(
  "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, personCertificationInformationId } = useParams({
    from: "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout",
  });
  const { data } = useGetPersonHandlingCertificationHeader(
    id,
    personCertificationInformationId,
  );
  return (
    <VStack className="gap-0">
      <CertificationProfileHeader
        personId={id}
        personCertificationInformationId={personCertificationInformationId}
        certificationName={data.personHandlingCertification.certificationName}
        certificationNumber={
          data.personHandlingCertification.certificationNumber
        }
        certificationStatus={
          data.personHandlingCertification.certificationStatus
        }
        certificationKind={CertificationKind.HANDLING}
        certificationHolder={{
          name: data.personHandlingCertification.certificationHolder.name,
          avatarUrl:
            data.personHandlingCertification.certificationHolder.avatarUrl ??
            undefined,
        }}
      />
      <Outlet />
    </VStack>
  );
}
